import React, { Component } from "react";
import { Helmet } from "react-helmet";
var configs = require("../../../../public/config.json");

import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import getDeliveryFee from "../../../lib/getDeliveryFee";
import getCalculateCheckoutTotal from "../../../lib/getCheckoutTotal";
import getDeliveryDetails from "../../../lib/getDeliveryDetail";
import getLocalData from "../../../lib/getLocalData";
import getItemOptions from "../../../lib/getItemOptions";

import { GlobalConsumer } from "../../../context/GlobalContext";

import CommonHeader from "../../Common/Header";
import AppErrors from "../../Common/AppErrors";
import AppInfo from "../../Common/AppInfo";
import Loading from "../../Common/Loading";

import {
  AddPromoCode,
  DeleteItem,
  AddAlsoAdded,
  UseLocalePoints,
  Payments,
  PointsDesktop,
  PromoDesktop,
  PaymentsDesktop
} from "../../../routes/screens/Restaurants/Products/CheckOutReq";

import AddressSubmit from "../../../routes/screens/Users/Addresses/Submit";
import SmsVerification from "../../../routes/screens/Users/Profile/SmsVerification";
import SubmitItem from "../../../routes/screens/Restaurants/Products/SubmitItem";
import Login from "../../../routes/screens/Auth/Login";
import PaymentSubmit from "../../../routes/screens/Users/Payment/Submit";
import OrderSubmitted from "../../../routes/screens/Restaurants/Products/CheckOutReq/OrderSubmitted";
import getAppStrings from "../../../lib/appStrings";
import StaticMap from "../../../routes/screens/Restaurants/Products/CheckOutReq/StaticMap";

export default class CheckOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateItem: false,
      itemId: "",
      userId: props.userId,
      calculatedDeliveryFee: 0,
      errorMessage: null,
      delivery: null,
      infoMessage: "",
      confirmTotal: null,
      showSmallAmountFeeInfo: false,
      smallAmountFeeInfoMessage: {}
    };
  }
  componentDidMount() {
    const total = this.handleCalculateTotal();

    if (total) {
      this.getDeliveryFee();
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (props.userId && props.userId !== state.userId) {
      return {
        userId: props.userId
      };
    }

    return null;
  }
  handleSmallAmountFeeInfo = () => {
    const { showSmallAmountFeeInfo } = this.state;
    const { restaurant } = this.props.basketData || {};
    const minOrderAmount = restaurant.minOrderAmount || 0;
    var body = document.body;
    if (showSmallAmountFeeInfo === false) {
      const info = getAppStrings(4039);
      if (info && info.message) {
        body.classList.add("body-overflow");
        this.setState({
          smallAmountFeeInfoMessage: {
            title: info.title,
            message: info.message.replace(
              "[:par1]",
              `${parseFloat(minOrderAmount).toFixed(2)}`
            )
          }
        });
      }
    } else {
      body.classList.remove("body-overflow");
    }
    this.setState({ showSmallAmountFeeInfo: !showSmallAmountFeeInfo });
  };
  getDeliveryFee = () => {
    const { deliveryFee, subTotal } = this.props.basketData || 0;
    let delivery = null;
    if (typeof deliveryFee === "object") {
      delivery = getDeliveryFee(deliveryFee, subTotal);
    } else {
      delivery = deliveryFee;
    }
    if (typeof delivery === "number") {
      this.setState({ calculatedDeliveryFee: delivery });
    }
  };

  handleCalculateTotal = () => {
    let { promo, pointsAmount, basketData, subTotal } = this.props;
    let localPointDiscount = parseInt(pointsAmount);
    if (!localPointDiscount) {
      localPointDiscount = 0;
    }
    
    const { calculatedDeliveryFee } = this.state;
    const { smallAmountFee } = basketData;
    const total =
      (basketData &&
        typeof basketData.total === "number" &&
        basketData.total) ||
      null;

    const { calculatedTotal } = getCalculateCheckoutTotal(
      subTotal,
      promo,
      localPointDiscount,
      calculatedDeliveryFee,
      total,
      smallAmountFee
    );
    return calculatedTotal;
  };
  handleConfirmBasket = () => {
    const {
      promo,
      pointsAmount,
      onConfirmBasket,
      checkConfirmable
    } = this.props;

    let promoCode = (promo && promo.code) || "";
    let points = pointsAmount || 0;

    if (checkConfirmable()) {
      Api.post(
        "/api/product/checkout/confirm",
        { promoCode, points },
        (response, errors) => {
          console.log(response, "confirm");
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            console.log(response, "code-basket!");
            if (response.code === 4023) {
              this.setState({ smsVerification: true });
            } else {
              var body = document.body;
              const errorMessage = getAppErrors(response.code);
              if (response.code === 4024 || response.code === 4025) {
                const param = response.params[0] || 0;
                const completedError = errorMessage.message.replace(
                  "[:par1]",
                  `${parseFloat(param).toFixed(2)}`
                );
                if (completedError) {
                  body.classList.add("body-overflow");
                  this.setState({
                    errorMessage: completedError
                  });
                }
              } else {
                body.classList.add("body-overflow");
                this.setState({
                  errorMessage:
                    (errorMessage && errorMessage.message) || response.message
                });
              }
            }
          } else {
            this.setState({ confirmTotal: response.confirmBasket }, () => {
              onConfirmBasket(response);
            });
          }
        }
      );
    }
  };
  handleUpdateItem = itemId => {
    var body = document.body;
    body.classList.add("body-overflow");
    this.setState({ updateItem: true, itemId });
  };
  handleSubmitItem = event => {
    event.preventDefault();
    var body = document.body;
    body.classList.remove("body-overflow");
    const { getNewBasket } = this.props;
    this.setState({ updateItem: false, itemId: "" }, () => {
      getNewBasket();
    });
  };
  handleClickBack = event => {
    event.preventDefault();
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({ updateItem: false, itemId: "" });
  };
  confirmChangeDelivery = selectedMethod => {
    const { canChangeDelivery, delivery } = this.props.basketData;
    if (canChangeDelivery && delivery !== selectedMethod) {
      const info = getAppStrings(4038);
      this.setState({
        delivery: selectedMethod,
        infoMessage: (info && info.message) || "Are you sure?"
      });
    } else {
      return;
    }
  };
  handleCloseDeliveryInfo = () => {
    this.setState({
      delivery: null,
      infoMessage: ""
    });
  };
  handleChangeDelivery = () => {
    const { delivery } = this.state;
    if (typeof delivery === "boolean") {
      Api.post("/api/basket/set/delivery", { delivery }, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response.code);
        } else {
          if (response.status) {
            const { getNewBasket } = this.props;
            getNewBasket();
          }
        }
        this.setState({
          delivery: null,
          infoMessage: ""
        });
      });
    }
  };
  handleCalculateTotalPoints = pointsAmount => {
    return (parseFloat(pointsAmount) * configs.ptsToGbp).toFixed(2);
  };
  getPromotionsText = () => {
    const { promo, basketData } = this.props;
    const { calculatedDeliveryFee } = this.state;
    const subTotal = basketData.subTotal || 0;
    let bodyText, amount;

    switch (promo.type) {
      case "AMOUNT":
        bodyText = `£${parseFloat(promo.amount).toFixed(2)}`;
        amount = parseFloat(promo.amount);
        break;
      case "PERCENT":
        if (promo.beforeAmount && promo.amount !== promo.beforeAmount) {
          bodyText = promo.amount;
        } else {
          bodyText = `£${parseFloat(
            (parseFloat(subTotal) * parseFloat(promo.amount)) / 100
          ).toFixed(2)}`;
        }
        amount = parseFloat(promo.amount);
        break;
      case "FREE_DELIVERY":
        bodyText = `£${parseFloat(calculatedDeliveryFee).toFixed(2)}`;
        amount = parseFloat(calculatedDeliveryFee);
        break;
      default:
        bodyText = "";
        amount = 0;
        break;
    }
    return { bodyText, amount };
  };
  handleCloseError = event => {
    const { onClickClose } = this.props;
    this.setState(
      {
        errorMessage: null
      },
      () => {
        if (onClickClose) {
          onClickClose(event);
        }
      }
    );
  };
  getText = (title, postalCode, flatNumber, routeName, isPostalCode) => {
    let text;
    if (title) {
      text = title;
    } else {
      if (isPostalCode) {
        text = postalCode;
      } else {
        if (flatNumber) {
          text = `${flatNumber} ${routeName}`;
        } else {
          text = routeName;
        }
      }
    }
    return text;
  };
  getMapUrl = () => {
    const { basketData } = this.props;
    const address =
      (basketData.delivery && basketData.address) ||
      basketData.restaurant.address;
    const { lat, lon } = address ? address : null;
    const markerIcon = `${window.location.origin}/png/locationHome.png`;
    return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&style=feature:poi|visibility:off&zoom=18&size=700x250&markers=icon:${markerIcon}|${lat},${lon}&&&key=AIzaSyDqIcW_O-zUO90BsNZQjed33BthNi19Egc`;
  };
  render() {
    const {
      updateItem,
      calculatedDeliveryFee,
      itemId,
      errorMessage,
      infoMessage,
      confirmTotal,
      smallAmountFeeInfoMessage,
      showSmallAmountFeeInfo
    } = this.state;
    const {
      basketData,
      points,
      promo,
      handleChangeStatus,
      removePromoCode,
      userId,
      mobileNumber,
      pointsAmount,
      closeDefaultStatus,
      addAlsoAdded,
      addPromoCode,
      deleteItem,
      loginSection,
      useLocalePoints,
      item,
      newAddress,
      smsVerificationSection,
      sendSmsVerificationKey,
      paymentSection,
      loading,
      promoDesktop,
      getNewBasket,
      pointsDesktop,
      payments,
      handleSelectNewPayment,
      addNewPayment,
      onSelectPayment,
      orderUid,
      pointsEarned,
      submitted,
      selectedPayment,
      closePromoDesktop,
      closePointDesktop,
      parentError
    } = this.props;
    const {
      address,
      items,
      peopleAlsoAdded,
      subTotal,
      smallAmountFee,
      restaurant,
      delivery,
      preOrder,
      canChangeDelivery
    } = basketData || "";

    const calculatedTotal = this.handleCalculateTotal();
    const localAddress = getLocalData("deliveryDetails");

    let restaurantCity = (restaurant && restaurant.address.city.slugName) || "";
    let types = restaurant.types || [];
    let restaurantDeliveryFee = restaurant.deliveryFee;
    const deliveryDetail = getDeliveryDetails(restaurantDeliveryFee);
    const mapUrl = this.getMapUrl();
    return (
      <React.Fragment>
        <Helmet>
          <title>Checkout</title>
          <meta property="og:title" content="Checkout" />
        </Helmet>
        {(loading && <Loading />) || <noscript />}
        <div className="container">
          <div className="row">
            <div className="col-sm-9">
              <CommonHeader />
              <div className="mb-10px">
                <div className="check-out mb-1 visible-xs">
                  <div className="d-flex justify-content-between">
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        window.location.href = `/restaurant/${restaurantCity}/${restaurant.address.slugAdminWard}/${restaurant.slugName}`;
                      }}
                    >
                      <a className="cursor-pointer">{restaurant.name}</a>
                      <div className="alt">
                        <div className="d-flex">
                          {types.map(
                            (type, i) =>
                              (types.length !== i + 1 && (
                                <p key={i}>{`${type.name},`}&nbsp;</p>
                              )) || <p key={i}>{type.name}</p>
                          )}
                        </div>
                        <p>{deliveryDetail}</p>
                      </div>
                    </div>
                    <div className="hide-xs">
                      <div className="comments s0" />
                    </div>
                  </div>
                </div>
                {/* .check-out */}
                <StaticMap divClass="hide-xs" mapUrl={mapUrl} />
                <div className="white-bg check-out-location-is hide-xs">
                  <a
                    className="cursor-pointer"
                    onClick={() => {
                      window.location.href = `/restaurant/${restaurantCity}/${restaurant.address.slugAdminWard}/${restaurant.slugName}`;
                    }}
                  >
                    <h2>{restaurant.name}</h2>
                  </a>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <div
                        className="d-flex align-items-center mb-1 cursor-pointer"
                        onClick={() =>
                          this.confirmChangeDelivery(true, canChangeDelivery)
                        }
                      >
                        <div className="check sm">
                          <label htmlFor="deliverTo">
                            <input
                              type="radio"
                              name="deliver"
                              id="deliverTo"
                              checked={delivery}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                        {/* /.check */}
                        <div className="d-flex align-items-center">
                          <span>Deliver To:&nbsp;</span>
                          <p className="bold-desktop">
                            {this.getText(
                              (address && address.title) || null,
                              localAddress && localAddress.postalCode,
                              localAddress && localAddress.flatNumber,
                              localAddress && localAddress.routeName,
                              localAddress && localAddress.isPostalCode
                            )}
                          </p>
                        </div>
                        {/* /.d-flex */}
                      </div>
                      {/* /.mb-1 */}
                      {(canChangeDelivery && (
                        <div
                          className={`d-flex align-items-center cursor-pointer`}
                          onClick={() =>
                            this.confirmChangeDelivery(false, canChangeDelivery)
                          }
                        >
                          <div className="check sm">
                            <label htmlFor="collectAt">
                              <input
                                type="radio"
                                name="deliver"
                                id="collectAt"
                                checked={!delivery}
                              />
                              <span className="checkmark" />
                            </label>
                          </div>
                          {/* /.check */}
                          <div className="d-flex align-items-center">
                            <span>Collect At:&nbsp;</span>
                            <p className="bold-desktop">{restaurant.name}</p>
                          </div>
                          {/* /.d-flex */}
                        </div>
                      )) || <noscript />}

                      {/* /.d-flex */}
                    </div>

                    <div className="right">
                      <span>{(preOrder && "Pick-up") || "Deliver"} In:</span>
                      <p className="bold-desktop">{preOrder || "ASAP"}</p>
                    </div>
                  </div>
                  {/* /.d-flex */}
                </div>
              </div>
              {/* /.mb-1 */}

              <div className="restaurant-detail checkout-page">
                <div className="delivery d-flex visible-xs">
                  <icon className="icon icon-location-white" />
                  <div>
                    <h5>
                      {(delivery && "Delivery To") || "Collection >"}{" "}
                      {(delivery &&
                        ((address && address.title && (
                          <span className="bold">{address.title}</span>
                        )) || (
                          <span className="bold">
                            {(localAddress && localAddress.routeName) || ""}
                          </span>
                        ))) || <span>{restaurant.name}</span>}
                    </h5>
                    {(delivery && (
                      <p>
                        {preOrder || "ASAP"} |{" "}
                        {(address && address.addressLine1) ||
                          (localAddress && localAddress.postalCode) ||
                          ""}{" "}
                        {(address && address.addressLine2) ||
                          (localAddress && localAddress.city) ||
                          ""}
                      </p>
                    )) || (
                      <p>
                        {preOrder || "ASAP"} | {restaurant.address.addressLine1}
                        , {restaurant.address.postalCode},{" "}
                        {restaurant.address.addressLine2}
                      </p>
                    )}
                  </div>
                </div>
                <div className="white-bg detail-item">
                  {(items &&
                    items.length &&
                    items.map((item, i) => (
                      <div
                        className="title d-flex justify-content-between "
                        key={i}
                      >
                        <a
                          className="cursor-pointer"
                          onClick={() =>
                            this.handleUpdateItem(
                              item.restaurantItemId || item.item_id
                            )
                          }
                        >
                          <div className="d-flex item-div">
                            <span>{item.name}</span>
                            {(item.types &&
                              item.types.length &&
                              item.types.map(type => (
                                <React.Fragment key={type.id}>
                                  <span
                                    className={`badge ${(type.id === 7 &&
                                      "blue") ||
                                      ""}`}
                                  >
                                    {type.name}
                                  </span>
                                </React.Fragment>
                              ))) || <noscript />}
                          </div>
                          <p className="light">
                            {getItemOptions(basketData, item.id)}
                          </p>
                        </a>
                        <div className="pricing pricing-checkout">
                          <div>
                            <span className="item-quantity">
                              {item.quantity}x
                            </span>
                          </div>
                          <p>£{parseFloat(item.totalAmount).toFixed(2)}</p>
                          <div>
                            <span
                              className="icon-trash-link"
                              onClick={e =>
                                handleChangeStatus(e, "deleteItem", item)
                              }
                            >
                              <icon className="icon icon-trash visible-xs" />
                              <icon className="icon icon-close hide-xs" />
                            </span>
                          </div>
                        </div>
                        {/* /.pricing */}
                      </div>
                    ))) || <noscript />}
                </div>
                {(peopleAlsoAdded && peopleAlsoAdded.length && (
                  <div className="checkout-foot white-bg">
                    <h6>People Also Added</h6>
                    <div className="overflow">
                      {peopleAlsoAdded.map(alsoAdded => (
                        <div className="item" key={alsoAdded.id}>
                          <div className="img">
                            {(alsoAdded.pictures &&
                              alsoAdded.pictures.length && (
                                <img src={alsoAdded.pictures[0].url} />
                              )) || <noscript />}
                          </div>
                          <div className="desc">
                            <a
                              className="cursor-pointer"
                              onClick={e =>
                                handleChangeStatus(e, "addAlsoAdded", alsoAdded)
                              }
                            >
                              {alsoAdded.name}
                            </a>
                            <p>£{parseFloat(alsoAdded.newAmount).toFixed(2)}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )) || <noscript />}
                <div className="checkout-promo white-bg visible-xs">
                  {(promo && promo.code && (
                    <p>
                      Promo code - {promo.code}{" "}
                      <a className="cursor-pointer" onClick={removePromoCode}>
                        Remove
                      </a>
                    </p>
                  )) || (
                    <p>
                      Have a discount?
                      <a
                        className="cursor-pointer"
                        onClick={e => handleChangeStatus(e, "addPromoCode")}
                      >
                        Add promo code
                      </a>
                    </p>
                  )}
                  {(points && (
                    <div className="row center-sm">
                      <div className="col-sm-6">
                        <p>
                          You have{" "}
                          <span className="color-blue bold">{points}</span>{" "}
                          eCoins
                        </p>
                        <a
                          className="btn btn-blue d-flex align-items-center cursor-pointer justify-content-center"
                          onClick={e =>
                            handleChangeStatus(e, "useLocalePoints")
                          }
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                            >
                              <path
                                fill="#FFF"
                                fillRule="nonzero"
                                d="M12.251 5.73c.693 0 1.249.571 1.249 1.27 0 .698-.556 1.27-1.249 1.27H1.75C1.056 8.27.5 7.698.5 7c0-.698.556-1.27 1.249-1.27H12.25zm-6.52 1V1.75C5.73 1.056 6.3.5 7 .5c.698 0 1.27.556 1.27 1.249V6.73h3.981c.135 0 .249.117.249.269 0 .152-.114.27-.249.27H8.27v4.981C8.27 12.944 7.7 13.5 7 13.5c-.698 0-1.27-.556-1.27-1.249V7.27H1.75C1.614 7.27 1.5 7.152 1.5 7c0-.152.114-.27.249-.27H5.73z"
                              />
                            </svg>
                          </span>
                          <span>Spend eCoins</span>
                        </a>
                      </div>
                    </div>
                  )) || <noscript />}
                </div>
                <div className="hide-xs row checkout-promo">
                  <div className="col-sm-6 left">
                    <div className="white-bg">
                      {(promoDesktop && (
                        <div className="code-form">
                          <PromoDesktop
                            points={points}
                            useAblePromoCodes={basketData.useAblePromoCodes}
                            getNewBasket={getNewBasket}
                            handleRemovePromo={removePromoCode}
                            promoCode={(promo && promo.code) || ""}
                            closePromoDesktop={closePromoDesktop}
                          />
                        </div>
                      )) ||
                        (promo.code && (
                          <div className="code-form">
                            <h5>Add Promo Code</h5>
                            <div className="applied d-flex align-items-center">
                              <div className="check sm">
                                <input type="radio" checked disabled />
                                <span className="checkmark" />
                              </div>
                              <p>
                                Promo code applied - <span>{promo.code}</span>
                              </p>
                              <a
                                className="cursor-pointer"
                                onClick={removePromoCode}
                              >
                                (remove)
                              </a>
                            </div>
                          </div>
                        )) || (
                          <div className="no-point">
                            <p>
                              <a
                                className="cursor-pointer"
                                onClick={e =>
                                  handleChangeStatus(e, "addPromoCode")
                                }
                              >
                                + Add Promo code
                              </a>
                            </p>
                          </div>
                        )}
                    </div>
                  </div>
                  {/* /.col-sm-6 */}
                  <div className="col-sm-6 right">
                    <div className="white-bg">
                      {(pointsDesktop && (
                        <PointsDesktop
                          points={points}
                          pointsAmount={pointsAmount}
                          calculatedTotal={calculatedTotal}
                          closeDefaultStatus={closeDefaultStatus}
                          closePointDesktop={closePointDesktop}
                        />
                      )) || (
                        <div className="no-point">
                          <a
                            className="cursor-pointer"
                            onClick={e =>
                              handleChangeStatus(e, "useLocalePoints")
                            }
                          >
                            + Use your Local E eCoins!
                          </a>

                          <p className="you-have-text">
                            You have <span>{points} eCoins</span>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* /.col-sm-6 */}
                </div>
                {/* /.checkout-promo */}
                <div className="checkout-total white-bg mt-10px">
                  <ul>
                    <li>
                      <p>Subtotal</p>
                      <p>£{parseFloat(subTotal).toFixed(2)}</p>
                    </li>
                    {(smallAmountFee && (
                      <li>
                        <p>Small Basket Fee</p>
                        <p
                          className="cursor-pointer"
                          onClick={this.handleSmallAmountFeeInfo}
                        >
                          <img
                            style={{ width: "10px", height: "10px" }}
                            src="/svg/info-icon.svg"
                          />
                          £{parseFloat(smallAmountFee).toFixed(2)}
                        </p>
                      </li>
                    )) || <noscript />}
                    {(calculatedDeliveryFee && (
                      <li>
                        <p>Delivery Fee</p>
                        <p>£{calculatedDeliveryFee.toFixed(2)}</p>
                      </li>
                    )) || <noscript />}
                    {(promo.code && this.getPromotionsText().amount && (
                      <li>
                        <p>
                          Promotion
                          {(promo.type === "FREE_DELIVERY" &&
                            " - Free Delivery") ||
                            ""}
                        </p>
                        <p>-{this.getPromotionsText().bodyText}</p>
                      </li>
                    )) || <noscript />}
                    {(parseInt(pointsAmount) && (
                      <li>
                        <p className="d-flex">
                          Local E eCoins - {pointsAmount} eCoins.
                          <p
                            className="light visible-xs cursor-pointer"
                            onClick={e =>
                              handleChangeStatus(e, "useLocalePoints")
                            }
                          >
                            (change)
                          </p>
                        </p>
                        <p>
                          -£
                          {this.handleCalculateTotalPoints(pointsAmount)}
                        </p>
                      </li>
                    )) || <noscript />}
                    <hr />
                    <li>
                      <p className="bold">Total</p>
                      <p>£{calculatedTotal}</p>
                    </li>
                  </ul>
                </div>
                <div className="fixed-btn checkout-btn visible-xs">
                  <a
                    className="cursor-pointer"
                    onClick={this.handleConfirmBasket}
                  >
                    <span>Checkout</span>
                  </a>
                </div>

                {(userId && (
                  <div className="hide-xs white-bg mt-10px desktop-checkout-payment">
                    <h4>Pay With</h4>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <PaymentsDesktop
                          payments={payments}
                          selectedPayment={selectedPayment}
                          onSelectPayment={item => onSelectPayment(item)}
                          walletPay={!parseFloat(calculatedTotal)}
                          onClickNewCard={handleSelectNewPayment}
                        />
                      </div>
                      <div className="">
                        <a
                          className="btn btn-blue cursor-pointer"
                          onClick={this.handleConfirmBasket}
                        >
                          <span>Complete Order</span>
                        </a>
                      </div>
                      {/* .checkout-btn */}
                    </div>
                    {/* .d.flex */}
                  </div>
                )) || (
                  <div className="fixed-btn checkout-btn hide-xs">
                    <a
                      className="cursor-pointer"
                      onClick={this.handleConfirmBasket}
                    >
                      <span>Continue to checkout</span>
                    </a>
                  </div>
                )}
              </div>
            </div>
            {/* .col-sm-9 */}
            <div className="col-sm-3 sidebar right-sidebar hide-xs">
              <div>
                <div className="also-bar mt-10px">
                  {(peopleAlsoAdded && peopleAlsoAdded.length && (
                    <React.Fragment>
                      <h4>People also added</h4>

                      <div className="white-bg">
                        <ul>
                          <li>
                            {peopleAlsoAdded.map((alsoAdded, index) => (
                              <React.Fragment key={index}>
                                <div className="img">
                                  {(alsoAdded.pictures &&
                                    alsoAdded.pictures.length && (
                                      <img src={alsoAdded.pictures[0].url} />
                                    )) || <noscript />}
                                </div>
                                <div className="desc">
                                  <a
                                    className="cursor-pointer"
                                    onClick={e =>
                                      handleChangeStatus(
                                        e,
                                        "addAlsoAdded",
                                        alsoAdded
                                      )
                                    }
                                  >
                                    {alsoAdded.name}
                                  </a>
                                  <p>
                                    £
                                    {parseFloat(alsoAdded.newAmount).toFixed(2)}
                                  </p>
                                </div>
                              </React.Fragment>
                            ))}
                          </li>
                        </ul>
                      </div>
                    </React.Fragment>
                  )) || <noscript />}
                </div>
                {/* .also-bar */}
              </div>
            </div>
            {/* .sidebar */}
          </div>
          {/* .row */}
        </div>
        <GlobalConsumer>
          {({ basketData, user }) => {
            const item =
              basketData.items.find(item => item.restaurantItemId === itemId) ||
              {};
            return updateItem ? (
              <SubmitItem
                itemId={itemId}
                isFreebie={item.isFreebie}
                restaurantItemId={itemId}
                restaurantId={restaurant.uid}
                onSubmitItem={this.handleSubmitItem}
                onClickBack={this.handleClickBack}
                userId={userId}
                basketData={basketData}
                status="update"
                allAddresses={user && user.addresses}
              />
            ) : null;
          }}
        </GlobalConsumer>
        {errorMessage && (
          <AppErrors
            message={errorMessage}
            onClickClose={this.handleCloseError}
          />
        )}
        {parentError && (
          <AppErrors
            message={parentError}
            onClickClose={this.handleCloseError}
          />
        )}
        {paymentSection && (
          <Payments
            pointsAmount={pointsAmount}
            basketData={basketData}
            confirmTotal={confirmTotal}
            points={points}
          />
        )}
        {infoMessage && (
          <AppInfo
            onSubmit={this.handleChangeDelivery}
            title={`Change ${(delivery && "Delivery") || "Collection"}`}
            message={infoMessage}
            buttonText="Change"
            onClickClose={this.handleCloseDeliveryInfo}
          />
        )}
        {showSmallAmountFeeInfo && (
          <AppErrors
            message={smallAmountFeeInfoMessage.message}
            title={smallAmountFeeInfoMessage.title}
            onClickClose={this.handleSmallAmountFeeInfo}
          />
        )}
        {deleteItem && (
          <DeleteItem item={item} closeDefaultStatus={closeDefaultStatus} />
        )}
        {useLocalePoints && (
          <UseLocalePoints
            points={points}
            pointsAmount={pointsAmount}
            calculatedTotal={calculatedTotal}
            closeDefaultStatus={closeDefaultStatus}
          />
        )}
        {addAlsoAdded && (
          <AddAlsoAdded
            item={item}
            delivery={delivery}
            userAddressId={address.id}
            closeDefaultStatus={closeDefaultStatus}
          />
        )}
        {addPromoCode && (
          <AddPromoCode
            closeDefaultStatus={closeDefaultStatus}
            deliveryFee={
              (basketData &&
                basketData.deliveryFee &&
                basketData.deliveryFee) ||
              null
            }
            subTotal={
              (basketData && basketData.subTotal && basketData.subTotal) || 0
            }
            points={points}
            useAblePromoCodes={basketData.useAblePromoCodes || null}
          />
        )}
        {smsVerificationSection && (
          <SmsVerification
            mobileNumber={mobileNumber}
            onSmsVerified={() => closeDefaultStatus("smsVerificationSection")}
            sendSmsVerificationKey={sendSmsVerificationKey}
            closeVerification={() =>
              closeDefaultStatus("smsVerificationSection")
            }
            route="checkout"
          />
        )}
        {addNewPayment && (
          <PaymentSubmit
            handleCloseSection={() => closeDefaultStatus("addNewPayment")}
          />
        )}
        {newAddress && (
          <AddressSubmit
            address={address}
            checkOut={true}
            handleCloseSection={closeDefaultStatus}
            handleCloseError={this.handleCloseError}
          />
        )}
        {loginSection && (
          <Login
            checkOut={true}
            onClose={closeDefaultStatus}
            firstSignup={true}
          />
        )}
        {submitted && (
          <OrderSubmitted
            points={points}
            orderUid={orderUid}
            restaurantName={restaurant.name}
            pointsEarned={pointsEarned}
          />
        )}
        {/* .container */}
      </React.Fragment>
    );
  }
}
